'use client';
import { c } from '@/lib/vster/theme';
import Icon from '../Icon';

interface TabDef { key: string; icon: string; label: string; count?: number | null }

interface Props {
  screen: string;
  navigate: (s: string) => void;
  tabs?: TabDef[]; // 없으면 탭바 미표시(대시보드/칸반 등 앱 화면용)
  children: React.ReactNode;
}

// 마이워크스페이스 상단 3탭 레이아웃 (프로필 · 알림설정 · 찜공고) — 부스터(Vster) 디자인 이식.
//   탭 클릭 → navigate(key) 로 실제 라우터 이동(URL 유지). 사이드바 없는 단일 컬럼.
//   tabs 미지정(AppShell 레거시 화면)이면 심플 제목만 표시.
export default function WorkspaceShell({ screen, navigate, tabs, children }: Props) {
  const hasTabs = !!(tabs && tabs.length > 0);

  return (
    <main className="vpad" style={{ maxWidth: 1180, margin: '0 auto', padding: '26px 24px 72px' }}>
      {hasTabs ? (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <span style={{
              width: 40, height: 40, borderRadius: '50%', background: c.actionSoft,
              display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none',
            }}><Icon name="business" size={20} color={c.actionDark} /></span>
            <div>
              <h1 style={{ fontSize: 26, fontWeight: 800, letterSpacing: '-.025em', margin: 0, color: c.ink }}>마이워크스페이스</h1>
              <div style={{ fontSize: 13, color: c.muted }}>프로필 · 알림 · 찜한 공고를 한곳에서</div>
            </div>
          </div>

          <div className="x-scroll" style={{
            display: 'flex', gap: 6, borderBottom: `1.5px solid ${c.line}`, marginBottom: 22,
            position: 'sticky', top: 60, zIndex: 20, background: c.bg,
          }}>
            {tabs!.map((t) => {
              const on = screen === t.key;
              return (
                <button
                  key={t.key}
                  onClick={() => navigate(t.key)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 7, padding: '11px 18px', marginBottom: -1.5, flexShrink: 0, whiteSpace: 'nowrap',
                    background: 'none', border: 'none', borderBottom: `2.5px solid ${on ? c.action : 'transparent'}`,
                    fontFamily: 'inherit', fontSize: 14.5, fontWeight: 600, color: on ? c.actionDark : c.muted, cursor: 'pointer',
                  }}
                >
                  <Icon name={t.icon} size={19} fill={on ? 1 : 0} />{t.label}
                  {t.count != null && (
                    <span className="num" style={{ fontSize: 11, background: c.actionSoft, color: c.actionDark, borderRadius: 999, padding: '1px 8px', fontWeight: 700 }}>{t.count}</span>
                  )}
                </button>
              );
            })}
          </div>
        </>
      ) : (
        <h1 style={{ fontSize: 24, fontWeight: 700, letterSpacing: '-.015em', margin: '0 0 16px', color: c.ink }}>마이워크스페이스</h1>
      )}

      <div style={{ animation: 'vfade .3s ease' }}>{children}</div>
    </main>
  );
}
